import { Chip, chipClasses, Stack } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import type { DiagramSeriesOption } from '../../types/DiagramSeries.types';

type SeriesChipProps = {
  seriesColor: string;
  isHighlighted: boolean;
  valueType: DiagramSeriesOption['valueType'];
};

export const DiagramSeriesChipsRoot = styled(Stack)(({ theme }) => ({
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

export const SeriesChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'seriesColor' && prop !== 'isHighlighted' && prop !== 'valueType',
})<SeriesChipProps>(({ theme, seriesColor, isHighlighted, valueType }) => ({
  borderColor: isHighlighted ? seriesColor : theme.palette.divider,
  borderStyle: valueType === 'boolean' ? 'dashed' : 'solid',
  color: isHighlighted ? seriesColor : theme.palette.text.secondary,
  backgroundColor: isHighlighted ? alpha(seriesColor, theme.palette.action.selectedOpacity) : 'transparent',
  boxShadow: `0 ${theme.spacing(0.5)} ${theme.spacing(0.5)} ${alpha(theme.palette.common.black, 0.25)}`,
  fontWeight: isHighlighted ? theme.typography.fontWeightMedium : theme.typography.fontWeightRegular,

  '&:hover': {
    backgroundColor: alpha(seriesColor, theme.palette.action.hoverOpacity),
  },

  [`& .${chipClasses.deleteIcon}`]: {
    color: 'inherit',
  },

  [`& .${chipClasses.icon}`]: {
    marginLeft: theme.spacing(0.5),
  },
}));
